import React, { useState, useEffect } from "react"
import { Container, Row, Col, Card, CardBody, Button, Alert } from "reactstrap"
import { withTranslation } from "react-i18next"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import EmailReportList from "./EmailReportList"
import EmailReportModal from "./EmailReportModal"
import { getAllEmailReportConfigs } from "../../helpers/email_report_helper"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

document.title = "Email Reports | Yogya"

const EmailReports = props => {
  const [configs, setConfigs] = useState([])
  const [loading, setLoading] = useState(true)
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedConfig, setSelectedConfig] = useState(null)
  const [refreshKey, setRefreshKey] = useState(0)

  // Fetch all configurations
  const fetchConfigs = async () => {
    try {
      setLoading(true)
      const response = await getAllEmailReportConfigs()
      setConfigs(response.configs || [])
    } catch (error) {
      console.error("Error fetching email report configs:", error)
      toastr.error("Failed to load email report configurations")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchConfigs()
  }, [refreshKey])

  const handleAddNew = () => {
    setSelectedConfig(null)
    setModalOpen(true)
  }

  const handleEdit = (config) => {
    setSelectedConfig(config)
    setModalOpen(true)
  }

  const handleModalClose = (shouldRefresh = false) => {
    setModalOpen(false)
    setSelectedConfig(null)
    if (shouldRefresh) {
      setRefreshKey(prev => prev + 1)
    }
  }

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Admin")}
            breadcrumbItem={props.t("Email Reports")}
          />

          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <h4 className="card-title mb-0">Email Report Configurations</h4>
                      <p className="text-muted mb-0">
                        Configure automated device status reports sent via email
                      </p>
                    </div>
                    <div>
                      <Button
                        color="primary"
                        onClick={handleAddNew}
                        className="me-2"
                      >
                        <i className="bx bx-plus me-1"></i>
                        Add Configuration
                      </Button>
                      <Button
                        color="secondary"
                        outline
                        onClick={handleRefresh}
                      >
                        <i className="bx bx-refresh"></i>
                      </Button>
                    </div>
                  </div>

                  {loading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : configs.length === 0 ? (
                    <Alert color="info">
                      <i className="bx bx-info-circle me-2"></i>
                      No email report configurations found. Click "Add Configuration" to create one.
                    </Alert>
                  ) : (
                    <EmailReportList
                      configs={configs}
                      onEdit={handleEdit}
                      onRefresh={handleRefresh}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <EmailReportModal
            isOpen={modalOpen}
            toggle={handleModalClose}
            config={selectedConfig}
            onSuccess={handleModalClose}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(EmailReports)
